const DIGITS = "۰۱۲۳۴۵۶۷۸۹";

export function fa(n: number | string): string {
  return String(n).replace(/\d/g, (d) => DIGITS[Number(d)]!);
}

/** «۱:۰۷» */
export function clock(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  return fa(`${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`);
}

/** «۱:۰۷٫۴» — زمانِ تمام‌کردن در پنلِ نتیجه. */
export function clockTenths(ms: number): string {
  return clock(ms) + "٫" + fa(Math.floor((Math.max(0, ms) % 1000) / 100));
}

/** آمارِ همین مرورگر — فقط برای خودِ بازیکن، نه سنجه‌ی ما. هر حالت جدا، چون زمان‌هایشان قابلِ مقایسه نیست. */
export interface Stats { played: number; wins: number; best: number | null }

const key = (mode: "solo" | "shared") => (mode === "shared" ? "bazivan.arrows.stats.shared" : "bazivan.arrows.stats");

export function loadStats(mode: "solo" | "shared"): Stats {
  try {
    const v = JSON.parse(localStorage.getItem(key(mode)) ?? "null") as Partial<Stats> | null;
    return { played: v?.played ?? 0, wins: v?.wins ?? 0, best: v?.best ?? null };
  } catch {
    return { played: 0, wins: 0, best: null };
  }
}

export function saveRace(mode: "solo" | "shared", win: boolean, finishedAt: number | null): Stats {
  const s = loadStats(mode);
  s.played++;
  if (win) s.wins++;
  if (finishedAt !== null && (s.best === null || finishedAt < s.best)) s.best = finishedAt;
  try { localStorage.setItem(key(mode), JSON.stringify(s)); } catch { /* حالتِ ناشناس: بی آمار هم بازی می‌شود */ }
  return s;
}
